import { combineReducers } from 'redux'

import agencyImporter from './agencyImporter'
import campaignFilters from './campaignFilters'
import invoiceFilters from './invoiceFilters'
import invoices from './invoices'
import userFilters from './userFilters'

export default combineReducers({
  agencyImporter,
  campaignFilters,
  invoices,
  invoiceFilters,
  userFilters,
})
